<script>
    import EmetersGroup from "../components/EmetersGroup.svelte";
    import ButtonHolder from "../components/ButtonHolder.svelte";

    import { subscribeIntegration, unsubscribeIntegration, updateIntegration } from "../https";
    import { emeters, integrated_list } from "../stores";
    import { push } from "svelte-spa-router";
    import { getContext, onMount } from "svelte";


    const { notification }= getContext('notification');
    let selected= [...$integrated_list] || [];
    
    const updateList = (e) => {
        const {id, select} = e.detail;
      
        if(id !== undefined && id !== ""){
            if(select){
      
                selected.push(id);    
      
            } else if(select === false) {
      
                selected = selected.filter(d => d !== id);
            }

        }
     
    };
    
    const updateIntegratedList = () => {
        integrated_list.updateIntegrated(selected)

    };

    const handle_unsubscribe = () => {
        unsubscribeIntegration()
        .then(res => {

            if(res.data.isok){
                integrated_list.updateIntegrated([]);
            }
        })
        .catch(err => {
            console.warn("failed");
        })
    } 
    const saveDevices = () => {
        // on empty array will clear user data
        // unsubscribe user
        if(selected.length === 0 ){
            notification.toggle_notification(2, "You have not any selected devices, you will be unsubscribed from integration!", ['Ok', 'Cancel'], handle_unsubscribe)

        } else {
            if($integrated_list.length > 0 ){
                
                updateIntegration(selected)
                .then(res => {
                    if(res.data.isok) {
                        updateIntegratedList()
                    } 
                })
                .catch(err => console.warn('error alert'));

            } else {
                
                subscribeIntegration(selected)
                .then(res => {
                    if(res.data.isok) updateIntegratedList();
                })
                .catch(err => console.warn('return error alert'));
                //on chaged update it
            }     
        }

        push("/subscribed_list")
    };

</script>

      
<section>
    <h3> ENERGY METERS </h3>
     <EmetersGroup {selected} on:update_selection={e => updateList(e)}/>
    {#if $emeters.length > 0}
        <ButtonHolder on:click={e => saveDevices()}>Save changes</ButtonHolder>
    {/if}
</section>

<style>
    section{
        display: flex;
        position: absolute;
        top: 15%;
        left: var(--display-main_content_left);

        height: var(--display-main_content_height);
        width: var(--display-main_content_width);
        /* justify-content: space-between; */
        align-items: center;
        flex-direction: column;
       
        /* border-left: 1px solid cornflowerblue;
        border-right: 1px solid cornflowerblue; */
       
    }
</style>